import { render } from "./CustomPageBuilder.vue?vue&type=template&id=17e1b620&scoped=true"
import script from "./CustomPageBuilder.vue?vue&type=script&lang=js"
export * from "./CustomPageBuilder.vue?vue&type=script&lang=js"

import "./CustomPageBuilder.vue?vue&type=style&index=0&id=17e1b620&lang=scss&scoped=true"

import exportComponent from "/home/ed/Desktop/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e1b620"]])

export default __exports__